import { render, staticRenderFns } from "./SurveyPage2.vue?vue&type=template&id=167357fb&scoped=true&"
import script from "./SurveyPage2.vue?vue&type=script&lang=js&"
export * from "./SurveyPage2.vue?vue&type=script&lang=js&"
import style0 from "./SurveyPage2.vue?vue&type=style&index=0&id=167357fb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.8_cache-loa_04cfefe4e5633ef36867eab2fc0c6666/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167357fb",
  null
  
)

export default component.exports